/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import { Sexe } from '@/enums';

// Valeurs acceptées (en minuscules) : enum Sexe, codes M/F/I, civilités
// ('M.'/'Mme'), libellés ('Masculin'/'Féminin'/'Indéterminé') et anciens
// libellés ('Monsieur'/'Madame').
const SEXE_BY_VALEUR: Record<string, Sexe> = {
  [Sexe.Homme]: Sexe.Homme,
  m: Sexe.Homme,
  'm.': Sexe.Homme,
  monsieur: Sexe.Homme,
  masculin: Sexe.Homme,
  [Sexe.Femme]: Sexe.Femme,
  f: Sexe.Femme,
  mme: Sexe.Femme,
  madame: Sexe.Femme,
  féminin: Sexe.Femme,
  [Sexe.Indetermine]: Sexe.Indetermine,
  i: Sexe.Indetermine,
  indéterminé: Sexe.Indetermine,
};

const toSexe = (valeur?: string | null): Sexe | undefined =>
  SEXE_BY_VALEUR[(valeur ?? '').toString().trim().toLowerCase()];

// L'API renvoie `sexe` en civilité ('M.'/'Mme'/'Non renseigné') et `sexeCode`
// en libellé ('Masculin'/'Féminin'/'Indéterminé') : on les ramène à l'enum Sexe
// attendu par EtatCivil / ParentForm. `sexeCode` prime car c'est lui qu'affiche
// la fiche, et les deux colonnes peuvent se contredire sur des données
// historiques. 'Inconnu' / 'Non renseigné' laissent le champ vide.
const resolveSexe = (
  sexe?: string | null,
  sexeCode?: string | null,
): Sexe | null => toSexe(sexeCode) ?? toSexe(sexe) ?? null;

export default resolveSexe;
